// extracted by mini-css-extract-plugin
export default {"colors":"TagColorList_colors__+5N+2"};